<template>
    <div>
        <div id="calendar" ref="calendar" class="w-100"></div>
    </div>
</template>

<script>
import flatpickr from "flatpickr";

export default {
    props: ['leave'],
    mounted() {
        this.initFlatpickr();
    },
    methods: {
        initFlatpickr() {
            const startDate = new Date(this.leave.start_date);
            const endDate = new Date(this.leave.end_date);

            flatpickr(this.$refs.calendar, {
                mode: "range",
                minDate: startDate.toISOString().split('T')[0], // YYYY-MM-DD
                maxDate: endDate.toISOString().split('T')[0],
                dateFormat: "Y-m-d",
                inline: true,
                showMonths: 2,
                onDayCreate: function (dObj, dStr, fp, dayElem) {
                    const date = dayElem.dateObj;
                    // Add class for selected date and weekend (Saturday and Sunday)
                    if (date >= startDate && date <= endDate) {
                        dayElem.classList.add('selected-date');

                        if (date.getDay() === 6 || date.getDay() === 0) {
                            dayElem.classList.add('weekend');
                        }
                    }
                },
                disable: [
                    function (date) {
                        // Disable dates outside the leave range
                        return date < startDate || date > endDate;
                    },
                ],
            });
        },
    },
};
</script>


<style>
.flatpickr-calendar {
    max-width: 100% !important;
}

.flatpickr-day.selected-date {
    background: #f0f8ff !important;
    color: #000 !important;
}

.flatpickr-day.weekend {
    background: #ffe4e1 !important;
    color: #999
}

#datePicker {
    display: none;
}
</style>
